import { Component } from '@angular/core';

@Component({
  selector: 'am-searchbox-skeleton',
  styleUrls: ['./searchbox-skeleton.component.scss'],
  templateUrl: './searchbox-skeleton.component.html',
})
export class SearchBoxSkeletonComponent {
  constructor() {}
}
